
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pdfReader/[book_id]",
      function () {
        return require("private-next-pages/pdfReader/[book_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pdfReader/[book_id]"])
      });
    }
  